import { useNavigate, useSearchParams } from '@remix-run/react';
import { useEffect, useState } from 'react';

// For references, pulled from: https://usehooks.com/useDebounce/
const useDebounce = (delay: any) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(searchParams.get('q') || '');
  const [isSearching, setIsSearching] = useState(false);
  const navigate = useNavigate();

  function checkPathForArchive() {
    if (!location.pathname.includes('/archive')) {
      navigate(`archive?q=${searchTerm}`);
    } else {
      setSearchParams(searchParams);
    }
  }

  useEffect(() => {
    const prevSearchTerm = searchParams.get('q') || '';
    // user has changed the search term so rest the page number
    if (searchTerm !== prevSearchTerm) {
      searchParams.delete('page');
      searchParams.set('q', searchTerm);
      setSearchParams(searchParams);
    }

    const handler = setTimeout(() => {
      if (searchTerm) {
        searchParams.set('q', searchTerm);
        checkPathForArchive();
      } else if (searchParams.has('q') && !searchTerm) {
        searchParams.delete('q');
        checkPathForArchive();
      }

      setIsSearching(false);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, delay, searchParams]);

  return { searchTerm, setSearchTerm, isSearching, setIsSearching };
};

export default useDebounce;
